import React from 'react';
import PropTypes from 'prop-types';

function GeneralSectionFieldItem(props) {
  const { label, content, link } = props;

  return (
    <div className="field generalSection_item">
      <label>{label}</label>
      <div>{link ? <a href={link}>{content}</a> : content}</div>
    </div>
  );
}

GeneralSectionFieldItem.propTypes = {
  label: PropTypes.string.isRequired,
  content: PropTypes.any,
  link: PropTypes.string
};

GeneralSectionFieldItem.defaultProps = {
  content: '',
  link: null
};

export default GeneralSectionFieldItem;
